import React from 'react';

const Contact = () => {
  return (
    <div>
      <h2>Contact us page</h2>
    </div>
  );
};

export default Contact;
